if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"pflm_b2gnew","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return 9121 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}